import {AppStoreState} from 'src/store';

export const LaneSelectSelectors = {
  getLane: (state: AppStoreState) => state.laneSelect,
};
